import React from 'react';
import { services } from '../data/services';
import { contact, images, urls } from '../data/site';
import { linkTargetProps } from '../utils/links';
const companyLinks = [{
  label: 'Our Work Gallery',
  href: urls.gallery
}, {
  label: 'Request a Quote',
  href: urls.quote
}, {
  label: 'Contact Page',
  href: urls.contact
}, {
  label: 'Trailer Body Repair',
  href: urls.trailer
}, {
  label: 'Make a Payment',
  href: urls.payment
}, {
  label: 'Careers',
  href: urls.careers
}, {
  label: 'Heavy Equipment Restoration',
  href: urls.heavyEquipment
}, {
  label: 'Repair Resources',
  href: urls.resources
}, {
  label: 'Privacy Policy',
  href: urls.privacy
}];
const linkClass = 'inline-flex min-h-[36px] items-center text-[15px] text-steel-light transition-colors duration-150 ease-out hover:text-paper';
export function SiteFooter() {
  return <footer className="bg-ink text-paper" data-id="element-386" data-mp="11qiozhcinv1e">
      <div className="mx-auto grid max-w-[1320px] gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-12 lg:px-12 lg:py-20" data-id="element-387" data-mp="wrpe7wom6i4x">
        <div className="lg:col-span-4" data-id="element-388" data-mp="15q2b6qo678a9">
          <span className="inline-block bg-paper px-4 py-3" data-id="element-389" data-mp="15t7yq1h5i23v">
            <img src={images.logo} alt="Motor City Truck Collision" className="h-10 w-auto max-w-[200px] object-contain" data-id="element-390" data-mp="1aqpz33h3r909" />
          </span>
          <p className="mt-6 max-w-[22rem] text-[15px] leading-relaxed text-steel-light" data-id="element-391" data-mp="vv1zxsqn5c38">
            Commercial truck collision repair, bodywork and painting in Brighton, Michigan.
          </p>
          <a href={contact.phoneHref} className="mt-6 inline-block font-display text-[28px] font-bold tracking-[0.02em] text-paper hover:text-brand-bright" data-id="element-392" data-mp="1ojpfd7opl78v">
            {contact.phoneDisplay}
          </a>
          <address className="mt-2 text-[15px] not-italic leading-relaxed text-steel-light" data-id="element-393" data-mp="1jpuwg6gxgwau">
            {contact.street}
            <br data-id="element-394" data-mp="27enx2g8hvsbs" />
            {contact.cityLine}
          </address>
        </div>

        <nav aria-label="Services" className="lg:col-span-3" data-id="element-395" data-mp="2c7z5umwvaj6c">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-396" data-mp="2m2xmtvi132a8">Services</h2>
          <ul className="mt-4" data-id="element-397" data-mp="2h42zcg948pjs">
            {services.map(s => <li key={s.title} data-id="element-398" data-mp="2h208xv41wuej">
                <a href={s.href} {...linkTargetProps(s.href)} className={linkClass} data-id="element-399" data-mp="2d1q26g8fpzym">
                  {s.title}
                </a>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Company" className="lg:col-span-2" data-id="element-400" data-mp="233s83c3w98y3">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-401" data-mp="2364vi4sf8bij">Company</h2>
          <ul className="mt-4" data-id="element-402" data-mp="1ybijbzeimexe">
            {companyLinks.map(l => <li key={l.label} data-id="element-403" data-mp="1tes75n5u03h9">
                <a href={l.href} {...linkTargetProps(l.href)} className={linkClass} data-id="element-404" data-mp="1pcndwpjap8v5">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-405" data-mp="1kfes8eyxump5">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-406" data-mp="1fe7n6no6k1m6">Our family</h2>
          <img src={images.garrettLogo} alt="Garrett Auto & Truck Service" loading="lazy" className="mt-5 h-12 w-auto max-w-[200px] object-contain" data-id="element-407" data-mp="3r11adwctvx0w" />
          <p className="mt-5 text-[15px] leading-relaxed text-steel-light" data-id="element-408" data-mp="4v4ffcpuzw4y">
            Part of the Garrett Auto &amp; Truck Service family. Garrett has served Southeast Michigan since 1958.
          </p>
          <a href={urls.garrett} {...linkTargetProps(urls.garrett)} className={`${linkClass} mt-2 text-paper underline decoration-brand underline-offset-4`} data-id="element-409" data-mp="38cwa4yvdqu6u">
            garrettauto.com
          </a>
        </div>
      </div>

      <div className="border-t border-ink-line" data-id="element-410" data-mp="3ha6myonuirdv">
        <div className="mx-auto flex max-w-[1320px] flex-col gap-2 px-5 py-6 text-[13px] text-steel-light sm:flex-row sm:justify-between sm:px-8 lg:px-12" data-id="element-411" data-mp="3m3ro2pkqk1ha">
          <p data-id="element-412" data-mp="2tmfddstowsga">© 2026 Motor City Truck Collision. All rights reserved.</p>
          <p data-id="element-413" data-mp="2tkm6qdj2u88a">Brighton, MI · Serving Southeast Michigan</p>
        </div>
      </div>
    </footer>;
}